export default {
  'menu.profile.basic': '基础详情页',
  'basicProfile.title.form': '参数审批流程表',
  'basicProfile.steps.commit': '提交修改',
  'basicProfile.steps.approval': '审批中',
  'basicProfile.steps.finish': '修改完成',
  'basicProfile.title.currentParams': '修改后参数',
  'basicProfile.title.originParams': '原参数',
  'basicProfile.title.video': '现视频参数',
  'basicProfile.title.preVideo': '原视频参数',
  'basicProfile.title.audio': '现音频参数',
  'basicProfile.title.preAudio': '原音频参数',
  'basicProfile.label.video.mode': '匹配模式',
  'basicProfile.label.video.acquisition.resolution': '采集分辨率',
  'basicProfile.label.video.acquisition.frameRate': '采集帧率',
  'basicProfile.label.video.encoding.resolution': '编码分辨率',
  'basicProfile.label.video.encoding.rate.min': '编码码率最小值',
  'basicProfile.label.video.encoding.rate.max': '编码码率最大值',
  'basicProfile.label.video.encoding.rate.default': '编码码率默认值',
  'basicProfile.label.video.encoding.frameRate': '编码帧率',
  'basicProfile.label.video.encoding.profile': '编码profile',
  'basicProfile.label.audio.mode': '匹配模式',
  'basicProfile.label.audio.acquisition.channels': '采集声道数',
  'basicProfile.label.audio.encoding.channels': '编码声道数',
  'basicProfile.label.audio.encoding.rate': '编码码率',
  'basicProfile.label.audio.encoding.profile': '编码 profile',
  'basicProfile.unit.audio.channels': '声道',
  'basicProfile.goBack': '返回',
  'basicProfile.cancel': '取消流程',
  'basicProfile.title.operationLog': '参数调整记录',
  'basicProfile.column.contentNumber': '内容编号',
  'basicProfile.column.updateContent': '调整内容',
  'basicProfile.column.status': '当前状态',
  'basicProfile.column.updateTime': '修改时间',
  'basicProfile.column.operation': '操作',
  'basicProfile.cell.pass': '已通过',
  'basicProfile.cell.auditing': '审核中',
  'basicProfile.cell.view': '查看',
};
